// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import HighchartsVue from 'highcharts-vue'
// import Chart from './components/Chart.vue'
import Highcharts from 'highcharts'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import VueSweetalert2 from 'vue-sweetalert2'
import VueTheMask from 'vue-the-mask'
import moment from 'moment'
import JsonExcel from 'vue-json-excel'
import VueClipboard from 'vue-clipboard2'

Vue.use(BootstrapVue, VueSweetalert2)
Vue.use(VueTheMask)
Vue.use(HighchartsVue)
Vue.use(require('vue-moment'))
Vue.use(VueClipboard)
Vue.component('downloadExcel', JsonExcel)

/* eslint-disable no-new */
window.moment = moment
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  },
  created () {
    router.beforeEach((to, from, next) => {
      document.body.classList.toggle('aside-menu-hidden', true)
      // document.body.style['overflow']='auto'
      next()
    })
  }
})
Highcharts.setOptions({
  lang: {
    thousandsSep: ','
  }
})



// WEBPACK FOOTER //
// ./src/main.js